// extracted by mini-css-extract-plugin
export default {"clearfix":"styles_clearfix__fOVct","badge":"styles_badge__YUZhb"};